import React from 'react';
import {toJS} from 'mobx';
import './index.scss';

//api
import { api } from '../../../../functions/api';

//other libraries
import { inject, observer } from 'mobx-react';


//material-ui
import { Paper, Grid, Collapse, List, ListItem, ListItemText } from '@material-ui/core';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';

//custom components
import CustomInput from '../../../../components/basic/input'

@inject('internal')
@inject('translate')
@observer
export default class ProductPrices extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            useSetPrice: false,
            useDiscountPrice: false,
            set_price: 0,
            discount_price: 0,
        }
    }

    componentDidMount() {
        this.setState({
            useDiscountPrice: toJS(this.props.internal.dataForSimpeTable.use_discount_price),
            discount_price: toJS(this.props.internal.dataForSimpeTable.discounted_price_with_vat),
            set_price: toJS(this.props.internal.dataForSimpeTable.set_price),
            useSetPrice: toJS(this.props.internal.dataForSimpeTable.use_set_price),
        })
    }

    formatPrice = (data) => {
        const formatter = new Intl.NumberFormat('sk-SK', {
            style: 'currency',
            currency: 'EUR',
            minimumFractionDigits: 2
        })
        return formatter.format(data)
    }

    formatPriceWithoutCurrency = (data) => {
        const formatter = new Intl.NumberFormat('sk-SK', {
            // style: 'currency',
            // currency: 'EUR',
            minimumFractionDigits: 2
        })
        return formatter.format(data)
    }

    handleClickCollapse = (field) => {
        this.setState({[field]: !this.state[field]}, this.handleSetPrice)
    }

    timeout = null
    handleSetPrice = (field, val) => {
        if(this.state.useSetPrice === true) {
            this.setState({set_price: this.set_price.state.value})
        }

        if(this.state.useDiscountPrice === true) {
            this.setState({discount_price: this.discount_price.state.value})
        }

        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
            this.updatePrices()
        }, 500)
    }

    formatCurrency(price) {
        return parseFloat(price.replace(/,/, '.').replace(/[^\d.]+/, ''));
    }

    updatePrices = async() => {

        let idProduct = this.props.routerData.match.params.idProduct

        let params = {
        }

        params.use_discount_price  = this.state.useDiscountPrice;
        if(this.state.useDiscountPrice === true) {
            params.discounted_price = this.formatCurrency(this.state.discount_price);
        }

        params.use_set_price  = this.state.useSetPrice;
        if(this.state.useSetPrice === true) {
            params.set_price = this.formatCurrency(this.state.set_price);
        }


        let update_data = await api({
            method: 'PATCH',
            url: `products/${idProduct}`,
            authorization: this.props.internal.user.access_token,
            params: params
        })

        if(update_data.success === true) {
            this.props.internal.setSnackbar(update_data.data.message, true)
        }
        else {
            this.props.internal.setSnackbar(update_data.data.message, true)
        }
    }

    render() {
        const permissions = toJS(this.props.internal.user.data.permissions.products)

        return (
            <div className={'just-text-prices'}>
            <Grid container spacing={16}>
                <Grid item sm={12} md={6}>
                    <Paper className={'container-prices'}>
                        <Grid container>
                            <Grid item sm={12} md={6}>
                                <div className={'item'}>
                                    <span>{this.props.translate.i18n.MODULES.PRODUCTS.RECOMMENDED_RETAIL_PRICE}</span>
                                    <p>{this.formatPrice(toJS(this.props.internal.dataForSimpeTable.retail_price))}</p>
                                </div>
                            </Grid>
                            <Grid item sm={12} md={6}>
                                <div className={'item'}>
                                    <span>{this.props.translate.i18n.MODULES.PRODUCTS.VAT}</span>
                                    <p>{toJS(this.props.internal.dataForSimpeTable.vat)+ "%"}</p>
                                </div>
                            </Grid>
                            <Grid item sm={12} md={6}>
                                <div className={'item'}>
                                    <span>{this.props.translate.i18n.MODULES.PRODUCTS.RABAT_1}</span>
                                    <p>{this.formatPrice(toJS(this.props.internal.dataForSimpeTable.rabat_1))}</p>
                                </div>
                            </Grid>
                            <Grid item sm={12} md={6}>
                                <div className={'item'}>
                                    <span>{this.props.translate.i18n.MODULES.PRODUCTS.RABAT_2}</span>
                                    <p>{this.formatPrice(toJS(this.props.internal.dataForSimpeTable.rabat_2))}</p>
                                </div>
                            </Grid>
                            <Grid item sm={12} md={6}>
                                <div className={'item'}>
                                    <span>{this.props.translate.i18n.MODULES.PRODUCTS.RABAT_3}</span>
                                    <p>{this.formatPrice(toJS(this.props.internal.dataForSimpeTable.rabat_3))}</p>
                                </div>
                            </Grid>
                            <Grid item sm={12} md={6}>
                                <div className={'item'}>
                                    <span>{this.props.translate.i18n.MODULES.PRODUCTS.RABAT_4}</span>
                                    <p>{this.formatPrice(toJS(this.props.internal.dataForSimpeTable.rabat_4))}</p>
                                </div>
                            </Grid>
                            <Grid item sm={12} md={6}>
                                <div className={'item'}>
                                    <span>{this.props.translate.i18n.MODULES.PRODUCTS.RABAT_5}</span>
                                    <p>{this.formatPrice(toJS(this.props.internal.dataForSimpeTable.rabat_5))}</p>
                                </div>
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
                <Grid item sm={12} md={6}>
                    <Paper className={'container-prices2'}>
                        <Grid container>
                            <Grid item sm={12}>
                                <ListItem
                                  button
                                  onClick={() => permissions.change_prices ? this.handleClickCollapse('useSetPrice') : () => {}}
                                  disabled={!permissions.change_prices}
                                  disableGutters
                                >
                                        <input
                                            id={"useSetPrice"}
                                            type="checkbox"
                                            checked={this.state.useSetPrice}
                                            className={'checkboxPayType'}
                                            disabled={!permissions.change_prices}
                                        />
                                        {/* <label htmlFor={"useSetPrice"}>{this.props.translate.i18n.MODULES.PAYMENTS.HOMECREDIT}</label> */}
                                        <ListItemText  primary={this.props.translate.i18n.MODULES.PRODUCTS.USE_SET_PRICE} className={'primary-text title'}/>
                                        {this.state.useSetPrice ? <ExpandLess /> : <ExpandMore />}
                                    </ListItem>
                                    <Collapse in={this.state.useSetPrice} timeout="auto" unmountOnExit>
                                    <List component="div" disablePadding>
                                        <CustomInput
                                            ref={ref => (this.set_price = ref)}
                                            text={this.props.translate.i18n.MODULES.PRODUCTS.SET_PRICE}
                                            value={ this.formatPriceWithoutCurrency(this.state.set_price)}
                                            id={'set_price'}
                                            className={'w-100'}
                                            required
                                            endAdornment={{position: 'end', value: '€'}}
                                            align={'right'}
                                            change={(val) => this.handleSetPrice('set_price', val)}
                                            disabled={!permissions.change_prices}
                                        />

                                    </List>
                                </Collapse>
                            </Grid>
                            <Grid item sm={12}>
                                <ListItem
                                  button
                                  onClick={() => permissions.change_prices ? this.handleClickCollapse('useDiscountPrice') : () => {}}
                                  disabled={!permissions.change_prices}
                                  disableGutters
                                >
                                        <input
                                            id={"useDiscountPrice"}
                                            type="checkbox"
                                            checked={this.state.useDiscountPrice}
                                            className={'checkboxPayType'}
                                        />
                                        {/* <label htmlFor={"useDiscountPrice"}>{this.props.translate.i18n.MODULES.PAYMENTS.HOMECREDIT}</label> */}
                                        <ListItemText  primary={this.props.translate.i18n.MODULES.PRODUCTS.USE_DISCOUNT_PRICE} className={'primary-text title'}/>
                                        {this.state.useDiscountPrice ? <ExpandLess /> : <ExpandMore />}
                                    </ListItem>
                                    <Collapse in={this.state.useDiscountPrice} timeout="auto" unmountOnExit>
                                    <List component="div" disablePadding>
                                        <CustomInput
                                            ref={ref => (this.discount_price = ref)}
                                            text={this.props.translate.i18n.MODULES.PRODUCTS.DISCOUNT_PRICE}
                                            value={ this.formatPriceWithoutCurrency(this.state.discount_price) }
                                            id={'discount_price'}
                                            className={'w-100'}
                                            required
                                            endAdornment={{position: 'end', value: '€'}}
                                            align={'right'}
                                            disabled={!permissions.change_prices}
                                            change={(val) => this.handleSetPrice('discount_price', val)}
                                        />

                                    </List>
                                </Collapse>
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
            </Grid>

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/products/edit/prices/index.js